import { Get } from "services";
import { ApiPath } from "paths";

export const getMewsOutlet = async ({ venueId }) => {
  const res = await Get(`${ApiPath.MEWS_OUTLET(venueId)}`);
  return res;
};
